import React from 'react'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import withDialog, { CallBackOpenDialog } from '../control/dialogAlert/withDialog'
// Demo Table
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'

type DialogAlertProps = CallBackOpenDialog
let DialogAlert = (props: DialogAlertProps) => {
    const { openDialog, closeDialog } = props
    const classes = useStyles()

    const onDialogSimple1 = () => {
        if (openDialog) {
            openDialog({
                title: 'Dialog text with button close',
                content: 'fooooooooooooooo',
                displayBtnClose: true,
            })
        }
    }

    const onDialogSimple11 = () => {
        if (openDialog) {
            openDialog({
                title: 'Dialog text with button close',
                content: 'fooooooooooooooo',
                displayBtnClose: true,
                afterBtnClose: () => {
                    // Your logic
                    globalThis.alert('afterBtnClose')
                },
            })
        }
    }

    const onDialogSimple2 = () => {
        if (openDialog) {
            openDialog({
                title: 'Dialog text with confirm',
                content: 'fooooooooooooooo',
                displayBtnSave: true,
                displayBtnCancel: true,
            })
        }
    }

    const onDialogSimple3 = () => {
        if (openDialog) {
            openDialog({
                title: 'Dialog text with confirm',
                content: 'fooooooooooooooo',
                displayBtnSave: true,
                displayBtnCancel: true,
                afterBtnSave: () => {
                    // Your logic
                    globalThis.alert('afterBtnSave')
                },
                afterBtnCancel: () => {
                    // Your logic
                    globalThis.alert('afterBtnCancel')
                },
            })
        }
    }

    const onDialogSimple4 = () => {
        if (openDialog) {
            openDialog({
                title: 'Dialog component',
                render: ComponentView,
                displayBtnClose: true,
                widthDialog: 'md',
            })
        }
    }

    return (
        <div className={classes.root}>
            <Grid container>
                <Grid item md={12}>
                    <Typography variant="h3" gutterBottom>
                        Dialog Alert
                    </Typography>
                    <Divider />
                </Grid>
                <Grid item md={12} sx={{ py: 2 }}>
                    <Stack spacing={2} direction="row">
                        <Button variant="outlined" onClick={onDialogSimple1}>
                            Dialog text with button close
                        </Button>
                        <Button variant="outlined" onClick={onDialogSimple11}>
                            Dialog text with button close (after close)
                        </Button>
                        <Button variant="outlined" onClick={onDialogSimple2}>
                            Dialog text with confirm
                        </Button>
                        <Button variant="outlined" onClick={onDialogSimple3}>
                            Dialog text with confirm (after confirm)
                        </Button>
                        <Button variant="outlined" onClick={onDialogSimple4}>
                            Dialog Component
                        </Button>
                    </Stack>
                </Grid>
            </Grid>
        </div>
    )
}

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(4),
        overflow: 'auto',
        height: '-webkit-fill-available',
    },
}))

const ComponentView = () => {
    function createData(name: string, calories: number, fat: number, carbs: number, protein: number) {
        return { name, calories, fat, carbs, protein }
    }

    const rows = [
        createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
        createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
        createData('Eclair', 262, 16.0, 24, 6.0),
        createData('Cupcake', 305, 3.7, 67, 4.3),
        createData('Gingerbread', 356, 16.0, 49, 3.9),
    ]

    return (
        <TableContainer component={Paper} sx={{ p: 1 }}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Dessert (100g serving)</TableCell>
                        <TableCell align="right">Calories</TableCell>
                        <TableCell align="right">Fat&nbsp;(g)</TableCell>
                        <TableCell align="right">Carbs&nbsp;(g)</TableCell>
                        <TableCell align="right">Protein&nbsp;(g)</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell component="th" scope="row">
                                {row.name}
                            </TableCell>
                            <TableCell align="right">{row.calories}</TableCell>
                            <TableCell align="right">{row.fat}</TableCell>
                            <TableCell align="right">{row.carbs}</TableCell>
                            <TableCell align="right">{row.protein}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

DialogAlert = withDialog(DialogAlert)
export default DialogAlert
